import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LOCALE } from '../api/client';

// ----------------------------------------------------------------------
// Every text of the site comes from the dashboard (GET /site → ui, pages…).
// i18next only carries the current language (from the URL: /ar/… is Arabic,
// the rest English) for the components that read i18n.language to choose
// the layout direction.
// ----------------------------------------------------------------------

i18n.use(initReactI18next).init({
  resources: { en: { translations: {} }, ar: { translations: {} } },
  lng: LOCALE,
  fallbackLng: 'en',
  ns: ['translations'],
  defaultNS: 'translations',
  interpolation: { escapeValue: false },
});

export default i18n;
